import React from 'react';
import { DESCRIPTION_INFO, TRANSACTIONS_PAGES } from './constants';
import FeedbackBar from '../feedbackBar/FeedbackBar';
import withShipment from '../../withShipment';
import { statusSelector } from '../../redux/selectors/global';
import { clearStatus } from '../../redux/actions/global';
import {
  employeesSelector,
  userInfoSelector,
} from '../../redux/selectors/auth';
import {
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  FormHelperText,
  IconButton,
  TextField,
  Tooltip,
} from '@material-ui/core';
import {
  deleteTransaction,
  listTransaction,
  rollOverRequestList,
  rollOverTransaction,
  saveTransaction,
} from '../../redux/actions/ticketOut';
import TransactionTable from './TransactionTable';
import {
  rollOverRequestsSelector,
  transactionSelector,
} from '../../redux/selectors/ticketOut';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import PaymentPopperTransaction from './PaymentPopperTransaction';
import SessionReportPdf from '../global/SessionReportPdf';
import CustomToolbar from '../global/CustomToolbar';
import { getEmployees } from '../../redux/actions/auth';
import RefreshIcon from '@material-ui/icons/Refresh';
import HistoryIcon from '@material-ui/icons/History';
import TransactionHistoryDialog from './TransactionHistoryDialog';
import InputAdornment from '@material-ui/core/InputAdornment';
import TransactionCategory from './TransactionCategory';
import SettingsIcon from '@material-ui/icons/Settings';
import { listCategory } from '../../redux/actions/settings';
import { categorySelector } from '../../redux/selectors/settings';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { listAllCustomers } from '../../redux/actions/customer';
import { customersSelector } from '../../redux/selectors/customer';
import {
  ROLE_MASTER_ADMIN,
  ROLE_MANAGER,
} from '../settings/ManageUsers/constants';
import InfoIcon from '@material-ui/icons/Info';
import CloseIcon from '@mui/icons-material/Close';
import FlipCameraIosIcon from '@mui/icons-material/FlipCameraIos';
import PhotoCameraIcon from '@mui/icons-material/PhotoCamera';
import compressTicketPhoto from '../ticketOut/compressTicketPhoto';
import '../ticketOut/TicketOut.css';
import WriteGuard from '../global/ReadOnly/WriteGuard';
import { CAMERA_ROLES, openRoleCamera } from '../Utils/cameraSettings';

// Descriptions that force a mandatory photo before the transaction can be
// saved. Kept lowercase for case-insensitive comparison against the (uppercased)
// description state. Mirrors the Ticket Out photo-requirement flow.
const PHOTO_REQUIRED_DESCRIPTION = 'extra match / lucky';

class Transaction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentPage: TRANSACTIONS_PAGES.TABLE,
      feedbackBarOpen: false,
      // Set synchronously on the first Accept/Decline click so a rapid
      // double-click can't dispatch a second /rollover request (which the
      // backend would turn into a duplicate transfer row). Cleared in the
      // callback (right before the page reloads).
      processingRequest: false,
      error: false,
      transactionId: null,
      amount: '',
      description: '',
      expenseType: null,
      comments: '',
      amounts: {
        5: 0,
        20: 0,
        50: 0,
        100: 0,
        500: 0,
      },
      requiredList: ['amount', 'description'],
      hideMenu: false,
      reportTrigger: 0,
      selectedEntries: [],
      isSelecting: false,
      isDialogOpen: false,
      selectedCustomerId: null,
      selectedEmployeeId: null,
      nameInput: null,
      isToolbar: false,
      isMobile: window.matchMedia('(max-width: 800px)').matches,
      // Mandatory-photo capture for "EXTRA MATCH / LUCKY" (mirrors Ticket Out).
      currentPhoto: null,
      photoPreviewUrl: null,
      photoError: null,
      isCameraOpen: false,
      cameraFacingMode: 'environment',
    };

    this.videoRef = React.createRef();
    this.canvasRef = React.createRef();
  }

  componentWillUnmount() {
    this.stopCamera();
    if (this.state.photoPreviewUrl) {
      URL.revokeObjectURL(this.state.photoPreviewUrl);
    }
  }

  componentDidMount() {
    const isToolbar = this.props.isToolbar;

    if (isToolbar === true || isToolbar === undefined) {
      this.props.rollOverRequestList({ userId: this.props.user.userId });
    }

    this.setState(
      {
        isToolbar: isToolbar !== false,
      },
      () => {}
    );

    this.props.listAllCustomers({
      locationId: this.props.user.selectedLocationId,
    });
    this.props.listCategory({ locationId: this.props.user.selectedLocationId });

    this.props.listTransaction({
      userId: this.props.userId ? this.props.userId : this.props.user.userId,
      clockId: this.props.clockId,
    });
    this.props.getEmployees({
      locationId: this.props.user.selectedLocationId,
    });
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      this.props.status.statusText &&
      prevProps.status.statusText !== this.props.status.statusText
    ) {
      this.openFeedbackBar();
    }
  }

  handleEmployeeChange = (event, newValue) => {
    this.setState({
      selectedEmployeeId: newValue ? newValue.userId : null,
    });
  };

  // The description Autocomplete normally lists the backend-managed
  // TransactionCategory records from `this.props.categories`. When the
  // Transaction form is opened from Employee Session → Edit Shift
  // Report, we append a synthetic "TRANSFER MONEY" option so a
  // supervisor can record an ad-hoc transfer against that shift. The
  // synthetic option is distinct from the existing "TRANSFER MONEY TO
  // EMPLOYEE" row, which still goes through the pending-transfer
  // accept/decline flow on the backend.
  // Employees eligible for the new "TRANSFER MONEY" description: all
  // users at the location EXCEPT Master Admins, Managers, and Reading
  // Guys. In practice this narrows the picker down to Supervisor /
  // Employee roles, and unlike "transfer money to employee" we do NOT
  // require the target to be currently online/clocked-in.
  getTransferMoneyEmployees = () => {
    const excluded = new Set([
      'ROLE_MASTER_ADMIN',
      'ROLE_MANAGER',
      'ROLE_READING_GUY',
    ]);
    const list = Array.isArray(this.props.employees)
      ? this.props.employees
      : [];
    return list.filter((e) => {
      const auths = Array.isArray(e.authorities)
        ? e.authorities.map((a) => (typeof a === 'string' ? a : a?.authority))
        : [];
      return !auths.some((a) => excluded.has(a));
    });
  };

  getDescriptionOptions = () => {
    const cats = Array.isArray(this.props.categories)
      ? this.props.categories
      : [];
    if (!this.props.fromEmployeeSession) return cats;
    if (cats.some((c) => c.name?.toUpperCase() === 'TRANSFER MONEY')) {
      return cats;
    }
    return [
      ...cats,
      { name: 'TRANSFER MONEY', expenseType: null, isGlobal: true },
    ];
  };

  handleCustomerChange = (event, newValue) => {
    this.setState({
      selectedCustomerId: newValue ? newValue.customerId : null,
    });
  };

  setBackMenu = (bool) => {
    this.setState({ hideMenu: bool });
    this.props.listCategory({ locationId: this.props.user.selectedLocationId });
  };

  clearAmounts = () => {
    this.setState({
      amounts: {
        5: 0,
        20: 0,
        50: 0,
        100: 0,
        500: 0,
      },
      amount: '',
    });
  };

  handleOpenDialog = () => {
    this.setState({ isDialogOpen: true });
  };

  // Close dialog function
  handleCloseDialog = () => {
    this.setState({ isDialogOpen: false }, () => {
      this.props.listTransaction({
        userId: this.props.userId ? this.props.userId : this.props.user.userId,
        clockId: this.props.clockId,
      });
    });
  };

  setCurrentPage = (newPage) => {
    this.setState({
      currentPage: newPage,
    });
  };

  displaySetting = () => {
    return (
      <TransactionCategory
        setCurrentPage={this.setCurrentPage}
        setBackMenu={this.setBackMenu}
        openFeedbackBar={this.openFeedbackBar}
      />
    );
  };

  handleEditRow = (row) => {
    this.setState(
      {
        transactionId: row.transactionId,
        comments: row.comments,
        amount: row.amount,
        type: row.type,
        description: row.description,
        expenseType: row.expenseType,
        selectedCustomerId: row.selectedCustomerId,
        selectedEmployeeId: row.selectedEmployeeId,
      },
      () => {}
    );
  };

  displayTable = () => {
    return (
      <TransactionTable
        isToolbar={this.state.isToolbar}
        deleteTransaction={this.props.deleteTransaction}
        bankList={this.props.transactions?.bankList}
        expenseList={this.props.transactions?.expenseList}
        nameById={this.props.transactions?.nameById}
        setCurrentPage={this.setCurrentPage}
        openFeedbackBar={this.openFeedbackBar}
        handleSelectTransaction={this.handleSelectTransaction}
        selectedEntries={this.state.selectedEntries}
        isSelecting={this.state.isSelecting}
        handleEditRow={this.handleEditRow}
        user={this.props.user}
      />
    );
  };

  handleSelectTransaction = (transactionId) => {
    const { selectedEntries } = this.state;
    let index = selectedEntries.indexOf(transactionId);
    if (index === -1) {
      selectedEntries.push(transactionId);
    } else {
      selectedEntries.splice(index, 1);
    }

    const isSelecting = selectedEntries.length > 0;

    this.setState({ selectedEntries, isSelecting });
  };

  displayCurrentPage = () => {
    switch (this.state.currentPage) {
      case TRANSACTIONS_PAGES.TABLE:
        return this.displayTable();
      case TRANSACTIONS_PAGES.SETTING:
        return this.displaySetting();
      default:
        return <div>We encountered an error. Please refresh the page.</div>;
    }
  };

  openFeedbackBar = (status, message) => {
    this.setState({
      feedbackStatus: status,
      feedbackMessage: message,
      feedbackBarOpen: true,
    });
  };

  closeFeedbackBar = () => {
    this.setState(
      { feedbackBarOpen: false, feedbackStatus: '', feedbackMessage: '' },
      () => {
        this.props.clearStatus();
      }
    );
  };

  handleNumberChange = (event) => {
    const { name, value } = event.target;

    const reg = /^[0-9\b]+$/;

    if (value === '' || reg.test(value)) {
      this.setState({ [name]: value });
    }
  };

  handleChange = (event) => {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  };

  refreshTransaction = () => {
    this.props.rollOverRequestList({ userId: this.props.user.userId });
  };

  // Generates the new employee-session shift PDF for this employee's latest
  // shift (bumping reportTrigger fires SessionReportPdf).
  fetchPdf = () => {
    this.setState((s) => ({ reportTrigger: s.reportTrigger + 1 }));
  };

  handleReportError = (message) => {
    this.openFeedbackBar('error', message);
  };

  handleRequest = (status, request) => {
    // Block re-entry: if a request is already in flight, ignore extra clicks.
    if (this.state.processingRequest) {
      return;
    }
    this.setState({ processingRequest: true });

    const callback = (error, response) => {
      if (error) {
        this.setState({ processingRequest: false });
        this.openFeedbackBar('error', response);
      } else {
        this.openFeedbackBar('success', response);
      }
      window.location.reload();
    };

    const data = {
      selectedEmployeeId: this.props.user.userId,
      transactionId: request.transactionId,
      status: status,
      type: request.description.toLowerCase().includes('cash left')
        ? 'cash-left'
        : null,
    };
    this.props.rollOverTransaction(data, callback);
  };

  // ── Mandatory photo for "EXTRA MATCH / LUCKY" ─────────────────────────────
  // Same live-camera capture used by Ticket Out: getUserMedia into a fullscreen
  // <video>, a frame grabbed to a hidden <canvas>, then client-side compression.
  // Works on both mobile and desktop (no <input capture>).
  isPhotoRequired = () =>
    (this.state.description || '').toLowerCase() === PHOTO_REQUIRED_DESCRIPTION;

  startCamera = async () => {
    try {
      const existing = this.videoRef.current?.srcObject;
      if (existing) {
        existing.getTracks().forEach((track) => track.stop());
      }
      const constraints = {
        video: {
          facingMode: { ideal: this.state.cameraFacingMode },
          width: { min: 1024, ideal: 1920, max: 3840 },
          height: { min: 720, ideal: 1080, max: 2160 },
          frameRate: { ideal: 60 },
        },
        audio: false,
      };
      const stream = await openRoleCamera(CAMERA_ROLES.GENERAL, constraints);
      const track = stream.getVideoTracks()[0];
      const capabilities = track.getCapabilities ? track.getCapabilities() : {};
      if (capabilities.focusMode?.includes('continuous')) {
        await track.applyConstraints({
          advanced: [{ focusMode: 'continuous' }],
        });
      }
      this.setState({ isCameraOpen: true, photoError: null });
      if (this.videoRef.current) {
        this.videoRef.current.srcObject = stream;
      }
    } catch (err) {
      alert('Camera access error: ' + err.message);
    }
  };

  stopCamera = () => {
    const stream = this.videoRef.current?.srcObject;
    if (stream) {
      stream.getTracks().forEach((track) => track.stop());
      this.videoRef.current.srcObject = null;
    }
    this.setState({ isCameraOpen: false });
  };

  switchCamera = () => {
    this.setState(
      (prev) => ({
        cameraFacingMode:
          prev.cameraFacingMode === 'environment' ? 'user' : 'environment',
      }),
      () => this.startCamera()
    );
  };

  capturePhoto = () => {
    const canvas = this.canvasRef.current;
    const video = this.videoRef.current;
    if (!canvas || !video) return;
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    const ctx = canvas.getContext('2d');
    ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageURL = canvas.toDataURL('image/jpeg', 0.8);
    this.stopCamera();
    this.handleCapturedDataUrl(imageURL);
  };

  handleCapturedDataUrl = async (dataUrl) => {
    try {
      const res = await fetch(dataUrl);
      const blob = await res.blob();
      const file = new File([blob], `transaction-${Date.now()}.jpeg`, {
        type: 'image/jpeg',
      });
      const compressed = await compressTicketPhoto(file);
      if (this.state.photoPreviewUrl) {
        URL.revokeObjectURL(this.state.photoPreviewUrl);
      }
      this.setState({
        currentPhoto: compressed,
        photoPreviewUrl: URL.createObjectURL(compressed),
        photoError: null,
      });
    } catch (message) {
      this.setState({
        currentPhoto: null,
        photoPreviewUrl: null,
        photoError:
          typeof message === 'string'
            ? message
            : 'Could not process the photo, please retake.',
      });
    }
  };

  removePhoto = () => {
    if (this.state.photoPreviewUrl) {
      URL.revokeObjectURL(this.state.photoPreviewUrl);
    }
    this.setState({
      currentPhoto: null,
      photoPreviewUrl: null,
      photoError: null,
    });
  };

  // Clears the captured photo after a successful save (called from the save
  // callbacks alongside the other field resets).
  clearPhotoState = () => {
    if (this.state.photoPreviewUrl) {
      URL.revokeObjectURL(this.state.photoPreviewUrl);
    }
    this.setState({
      currentPhoto: null,
      photoPreviewUrl: null,
      photoError: null,
    });
  };

  renderPhotoRequirement = () => {
    const { currentPhoto, photoPreviewUrl, photoError } = this.state;
    return (
      <div className="transaction-photo-panel">
        <div className="transaction-photo-panel__header">
          <PhotoCameraIcon fontSize="small" />
          <span>Photo required for EXTRA MATCH / LUCKY</span>
        </div>
        {photoPreviewUrl ? (
          <div className="transaction-photo-preview">
            <img src={photoPreviewUrl} alt="Transaction" />
            <div className="transaction-photo-preview__actions">
              <Button size="small" onClick={this.startCamera}>
                Retake
              </Button>
              <Button size="small" color="secondary" onClick={this.removePhoto}>
                Remove
              </Button>
            </div>
          </div>
        ) : (
          <Button
            variant="outlined"
            color="primary"
            startIcon={<PhotoCameraIcon />}
            onClick={this.startCamera}
          >
            {currentPhoto ? 'Retake Photo' : 'Take Photo'}
          </Button>
        )}
        {photoError && <FormHelperText error>{photoError}</FormHelperText>}
      </div>
    );
  };

  renderCameraOverlay = () => (
    <>
      {this.state.isCameraOpen && (
        <div className="camera-view-container">
          <video
            ref={this.videoRef}
            autoPlay
            playsInline
            muted
            className="video-ref"
          />
          <button
            type="button"
            onClick={this.stopCamera}
            className="camera-close-button"
            aria-label="Close Camera"
          >
            <CloseIcon />
          </button>
          <button
            type="button"
            onClick={this.capturePhoto}
            className="capture-button"
            aria-label="Capture Photo"
          >
            <span className="capture-icon"></span>
          </button>
          <button
            type="button"
            onClick={this.switchCamera}
            className="flip-camera-button"
            aria-label="Switch Camera"
          >
            <FlipCameraIosIcon />
          </button>
        </div>
      )}
      <canvas ref={this.canvasRef} style={{ display: 'none' }} />
    </>
  );

  render() {
    const { amounts } = this.state;
    let headerButtons;
    headerButtons = [];
    headerButtons.push(
      {
        icon: <LocalAtmIcon />,
        title: 'Set Cash Left',
        handler: () => this.handleOpenDialog(),
      },
      // Transaction categories ("Add description") are location-level
      // settings, not shift data — Managers run the location day to day
      // and need them alongside Master Admins. The backend already
      // allows it (editCategory/listCategory accept ROLE_ADMIN, which
      // every Manager carries), so this was a client-only gate.
      ...(this.props.user?.authority?.some((a) =>
        [ROLE_MASTER_ADMIN, ROLE_MANAGER].includes(a)
      )
        ? [
            {
              icon: <SettingsIcon />,
              title: 'Add description',
              handler: () => {
                this.setBackMenu(true);
                this.setCurrentPage(TRANSACTIONS_PAGES.SETTING, {});
              },
            },
          ]
        : []),
      {
        icon: <VisibilityIcon />,
        title: 'View Report',
        handler: () => this.fetchPdf(),
      },
      {
        icon: <HistoryIcon />,
        title: 'My Transfer History',
        handler: () => this.setState({ historyOpen: true }),
      },
      {
        icon: <RefreshIcon />,
        title: 'Refresh for rollover requests',
        handler: () => this.refreshTransaction(),
      }
    );

    return (
      <React.Fragment>
        {/*<ErrorFeedbackBar/>*/}
        <FeedbackBar
          open={this.state.feedbackBarOpen}
          handleClose={this.closeFeedbackBar}
          severity={this.state.feedbackStatus}
          message={this.state.feedbackMessage}
        />

        {!this.state.hideMenu && this.state.isToolbar && (
          <CustomToolbar
            title={`Transaction (${this.props.user.firstname})`}
            createTitle={''}
            backTitle={''}
            headerButtons={headerButtons}
          />
        )}

        <TransactionHistoryDialog
          open={!!this.state.historyOpen}
          onClose={() => this.setState({ historyOpen: false })}
          userId={this.props.user?.userId}
          customers={this.props.customers}
          employees={this.props.employees}
        />

        <Dialog
          open={this.state.isDialogOpen}
          onClose={this.handleCloseDialog}
          maxWidth="sm"
          fullWidth
        >
          <DialogTitle>Set Cash Left</DialogTitle>
          <DialogContent>
            <PaymentPopperTransaction
              isMobile={this.state.isMobile}
              employees={this.props.employees}
              userId={this.props.user.userId} // Passing the userId prop
              openFeedbackBar={this.openFeedbackBar} // Passing the feedback bar handler
              handleClosePopper={this.handleCloseDialog} // Close the dialog when save or close
            />
          </DialogContent>
        </Dialog>

        {!this.state.hideMenu ? (
          <>
            {this.props.rollOverRequests &&
              this.props.rollOverRequests.length > 0 && (
                <div
                  style={{
                    margin: '16px',
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      marginBottom: '16px',
                    }}
                  >
                    <h3
                      style={{
                        margin: 0,
                        fontSize: '1.2rem',
                        color: '#111827',
                        fontWeight: 'bold',
                      }}
                    >
                      Pending Requests
                    </h3>
                    <span
                      style={{
                        backgroundColor: '#3b82f6',
                        color: 'white',
                        padding: '2px 10px',
                        borderRadius: '12px',
                        fontSize: '0.8rem',
                      }}
                    >
                      {this.props.rollOverRequests.length} Pending
                    </span>
                  </div>

                  <div style={{ display: 'grid', gap: '12px' }}>
                    {this.props.rollOverRequests.map((request) => (
                      <div
                        key={request.transactionId}
                        style={{
                          backgroundColor: 'white',
                          padding: '16px',
                          borderRadius: '10px',
                          boxShadow: '0 2px 4px rgba(0,0,0,0.05)',
                          display: 'flex',
                          flexDirection: 'column',
                          border: '1px solid #e5e7eb',
                          gap: '12px',
                        }}
                      >
                        {/* Top Row: Sender Info & Amount */}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-start',
                          }}
                        >
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '10px',
                            }}
                          >
                            {/* Simple Avatar Circle */}
                            <div
                              style={{
                                width: '36px',
                                height: '36px',
                                borderRadius: '50%',
                                backgroundColor: '#e0e7ff',
                                color: '#4338ca',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 'bold',
                                fontSize: '0.9rem',
                              }}
                            >
                              {request.senderName?.charAt(0).toUpperCase() ||
                                '?'}
                            </div>
                            <div>
                              <div
                                style={{
                                  fontSize: '0.75rem',
                                  color: '#6b7280',
                                  textTransform: 'uppercase',
                                  letterSpacing: '0.05em',
                                }}
                              >
                                Sent By
                              </div>
                              <div
                                style={{
                                  fontWeight: '700',
                                  color: '#111827',
                                }}
                              >
                                {request.senderName}
                              </div>
                            </div>
                          </div>
                          <div style={{ textAlign: 'right' }}>
                            <div
                              style={{
                                fontSize: '1.2rem',
                                fontWeight: '800',
                                color: '#059669',
                              }}
                            >
                              $
                              {parseFloat(request.amount).toLocaleString(
                                undefined,
                                { minimumFractionDigits: 2 }
                              )}
                            </div>
                          </div>
                        </div>

                        <hr
                          style={{
                            border: '0',
                            borderTop: '1px solid #f3f4f6',
                            margin: '0',
                          }}
                        />

                        {/* Middle Row: Details */}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'flex-end',
                          }}
                        >
                          <div>
                            <div
                              style={{
                                fontSize: '0.9rem',
                                color: '#374151',
                                fontWeight: '500',
                              }}
                            >
                              {request.description}
                            </div>
                            <div
                              style={{
                                fontSize: '0.8rem',
                                color: '#9ca3af',
                                marginTop: '2px',
                              }}
                            >
                              {request.date}
                            </div>
                            {request.comments && (
                              <div
                                style={{
                                  fontSize: '0.8rem',
                                  color: '#6b7280',
                                  fontStyle: 'italic',
                                  marginTop: '4px',
                                }}
                              >
                                "{request.comments}"
                              </div>
                            )}
                          </div>

                          {/* Action Buttons */}
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <button
                              disabled={this.state.processingRequest}
                              onClick={() =>
                                this.handleRequest('Reject', request)
                              }
                              style={{
                                backgroundColor: 'white',
                                color: '#dc2626',
                                padding: '8px 16px',
                                borderRadius: '6px',
                                border: '1px solid #fca5a5',
                                fontWeight: '600',
                                cursor: this.state.processingRequest
                                  ? 'not-allowed'
                                  : 'pointer',
                                opacity: this.state.processingRequest ? 0.6 : 1,
                              }}
                            >
                              Decline
                            </button>
                            <button
                              disabled={this.state.processingRequest}
                              onClick={() =>
                                this.handleRequest('Accept', request)
                              }
                              style={{
                                backgroundColor: '#059669',
                                color: 'white',
                                padding: '8px 16px',
                                borderRadius: '6px',
                                border: 'none',
                                fontWeight: '600',
                                cursor: this.state.processingRequest
                                  ? 'not-allowed'
                                  : 'pointer',
                                opacity: this.state.processingRequest ? 0.6 : 1,
                                boxShadow: '0 2px 4px rgba(5, 150, 105, 0.2)',
                              }}
                            >
                              Accept
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

            {/* The bank / expense entry form. Removed at a VIEW-ONLY
                location — the Bank and Expenses tables below stay, so a
                viewer still sees every transaction, they just aren't handed
                a form they could fill in and then not be allowed to save.
                See constants/readOnlyAccess.js. */}
            <WriteGuard>
              {this.state.isMobile ? (
                <div
                  className="rowSpecMasterTransaction"
                  style={{ marginTop: '24px' }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      width: '100%',
                      marginRight: '16px',
                    }}
                  >
                    <Autocomplete
                      className="input-text-field"
                      style={{ width: '100%' }}
                      options={this.getDescriptionOptions()}
                      getOptionLabel={(option) => option.name || ''}
                      // Match the value based on Uppercase for production consistency
                      value={
                        this.state.description
                          ? this.getDescriptionOptions().find(
                              (cat) =>
                                cat.name.toUpperCase() ===
                                this.state.description.toUpperCase()
                            )
                          : null
                      }
                      onChange={(e, value) => {
                        this.setState({
                          description: value ? value.name.toUpperCase() : '',
                          expenseType:
                            value && value.expenseType
                              ? value.expenseType
                              : null,
                          // Removed showInfo: !!value so it stays hidden until clicked
                        });
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="description"
                          label="Description"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                          required={this.state.requiredList.includes(
                            'description'
                          )}
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <React.Fragment>
                                <InputAdornment position="end">
                                  <Tooltip title="View Info">
                                    <IconButton
                                      size="small"
                                      // Manual toggle only
                                      onClick={() =>
                                        this.setState({
                                          showInfo: !this.state.showInfo,
                                        })
                                      }
                                      color={
                                        this.state.showInfo
                                          ? 'primary'
                                          : 'default'
                                      }
                                      // Optional: disable if no description is selected
                                      disabled={!this.state.description}
                                    >
                                      <InfoIcon fontSize="medium" />
                                    </IconButton>
                                  </Tooltip>
                                </InputAdornment>
                                {params.InputProps.endAdornment}
                              </React.Fragment>
                            ),
                          }}
                        />
                      )}
                    />

                    {this.state.showInfo &&
                      this.state.description &&
                      DESCRIPTION_INFO[
                        this.state.description.toUpperCase()
                      ] && (
                        <div
                          className="input-text-field"
                          style={{
                            padding: '10px 14px',
                            backgroundColor: 'white',
                            border: '1px solid #1976d2',
                            borderLeft: '5px solid #1976d2',
                            borderRadius: '4px',
                            position: 'relative',
                          }}
                        >
                          <FormHelperText
                            style={{
                              color: '#1976d2',
                              fontSize: '0.85rem',
                              margin: 0,
                              lineHeight: '1.4',
                            }}
                          >
                            <strong>Note:</strong>{' '}
                            {
                              DESCRIPTION_INFO[
                                this.state.description.toUpperCase()
                              ]
                            }
                          </FormHelperText>
                        </div>
                      )}
                  </div>

                  {(this.state.description.toLowerCase() === 'customer loans' ||
                    this.state.description.toLowerCase() === 'zelle' ||
                    this.state.description.toLowerCase() ===
                      'extra match / lucky' ||
                    this.state.description.toLowerCase() ===
                      'customer pay loans') && (
                    <Autocomplete
                      className="input-text-field"
                      options={this.props.customers}
                      getOptionLabel={(option) =>
                        `${option.firstName} ${option.lastName}`
                      }
                      value={
                        this.state.selectedCustomerId
                          ? this.props.customers.find(
                              (c) =>
                                c.customerId === this.state.selectedCustomerId
                            ) || null
                          : null
                      }
                      onChange={this.handleCustomerChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          name="customer"
                          label="Select Customer"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                      filterOptions={(options, { inputValue }) => {
                        return options.filter(
                          (c) =>
                            c.firstName
                              .toLowerCase()
                              .includes(inputValue.toLowerCase()) ||
                            c.lastName
                              .toLowerCase()
                              .includes(inputValue.toLowerCase())
                        );
                      }}
                      clearOnEscape
                    />
                  )}

                  {this.isPhotoRequired() && this.renderPhotoRequirement()}

                  {this.state.description.toLowerCase() ===
                    'manager loan to bank' && (
                    <TextField
                      className="input-text-field"
                      variant="outlined"
                      label="Name"
                      InputLabelProps={{ shrink: true }}
                      name="name"
                      value={this.state.nameInput}
                      onChange={(e) => {
                        const value = e.target.value;
                        const capitalized =
                          value.charAt(0).toUpperCase() + value.slice(1);
                        this.setState({ nameInput: capitalized });
                      }}
                    />
                  )}

                  {(this.state.description.toLowerCase() ===
                    'employee short payment' ||
                    this.state.description.toLowerCase() ===
                      'transfer money to employee' ||
                    this.state.description.toLowerCase() ===
                      'transfer money') && (
                    <Autocomplete
                      className="input-text-field"
                      options={
                        this.state.description.toLowerCase() ===
                        'transfer money'
                          ? this.getTransferMoneyEmployees()
                          : (Array.isArray(this.props.employees)
                              ? this.props.employees
                              : []
                            ).filter((employee) => employee.isOnline === true)
                      }
                      getOptionLabel={(option) =>
                        [option.firstname, option.lastname]
                          .filter(Boolean)
                          .join(' ')
                      }
                      value={
                        this.state.selectedEmployeeId
                          ? this.props.employees.find(
                              (c) => c.userId === this.state.selectedEmployeeId
                            ) || null
                          : null
                      }
                      onChange={this.handleEmployeeChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          name="employee"
                          label="Select Employee"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                      filterOptions={(options, { inputValue }) => {
                        return options.filter((c) => {
                          const fullName = [c.firstname, c.lastname]
                            .filter(Boolean)
                            .join(' ')
                            .toLowerCase();
                          return fullName.includes(inputValue.toLowerCase());
                        });
                      }}
                      clearOnEscape
                    />
                  )}

                  {this.state.description.toLowerCase() === 'zelle' && (
                    <Autocomplete
                      className="input-text-field"
                      options={
                        Array.isArray(this.props.employees)
                          ? this.props.employees
                          : [this.props.employees]
                      }
                      getOptionLabel={(option) =>
                        [option.firstname, option.lastname]
                          .filter(Boolean)
                          .join(' ')
                      }
                      value={
                        this.state.selectedEmployeeId
                          ? this.props.employees.find(
                              (c) => c.userId === this.state.selectedEmployeeId
                            ) || null
                          : null
                      }
                      onChange={this.handleEmployeeChange}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          required
                          name="employee"
                          label="Funds deposited to account of"
                          variant="outlined"
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                      filterOptions={(options, { inputValue }) => {
                        return options.filter((c) => {
                          const fullName = [c.firstname, c.lastname]
                            .filter(Boolean)
                            .join(' ')
                            .toLowerCase();
                          return fullName.includes(inputValue.toLowerCase());
                        });
                      }}
                      clearOnEscape
                    />
                  )}

                  <TextField
                    className="input-text-field"
                    variant="outlined"
                    label="Amount"
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">$</InputAdornment>
                      ),
                    }}
                    name="amount"
                    value={this.state.amount}
                    onChange={this.handleNumberChange}
                    required={this.state.requiredList.includes('amount')}
                  />

                  <TextField
                    variant="outlined"
                    label="Comments"
                    className="single-line-field"
                    InputLabelProps={{ shrink: true }}
                    name="comments"
                    value={this.state.comments}
                    onChange={this.handleChange}
                    multiline
                    minRows={2}
                    maxRows={6}
                  />

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginLeft: '10px',
                      marginRight: '10px',
                      marginTop: '10px',
                    }}
                  >
                    <Button
                      style={{
                        height: '55px',
                        flex: 1,
                        marginRight: '10px',
                        borderRadius: '0',
                      }}
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        // Block re-entry: ignore extra taps while a save is in flight.
                        if (this.state.processingRequest) {
                          return;
                        }
                        this.setState({ processingRequest: true });
                        const callback = (error, response) => {
                          if (error) {
                            this.openFeedbackBar('error', response);
                          } else {
                            this.openFeedbackBar('success', response);
                          }
                          this.setState({
                            processingRequest: false,
                            transactionId: null,
                            amount: '',
                            description: '',
                            comments: '',
                            nameInput: null,
                            expenseType: null,
                            selectedCustomerId: null,
                            selectedEmployeeId: null,
                          });
                          this.clearAmounts();
                          this.clearPhotoState();
                        };
                        this.props.saveTransaction(
                          {
                            transactionId: this.state.transactionId,
                            amount: this.state.amount,
                            description: this.state.description,
                            comments: this.state.comments,
                            userId: this.props.userId
                              ? this.props.userId
                              : this.props.user.userId,
                            locationId: this.props.user.selectedLocationId,
                            selectedCustomerId: this.state.selectedCustomerId,
                            selectedEmployeeId: this.state.selectedEmployeeId,
                            nameInput: this.state.nameInput,
                            expenseType: this.state.expenseType,
                            modifyUserId: this.props.userId
                              ? this.props.user.userId
                              : null,
                            clockId: this.props.clockId,
                            type: 'bank',
                            amounts: amounts,
                          },
                          callback
                        );
                      }}
                      disabled={
                        this.state.processingRequest ||
                        (() => {
                          const desc = this.state.description?.toLowerCase();
                          const amount = this.state.amount;

                          if (desc === 'customer loans') {
                            return true;
                          }

                          if (desc === 'extra match / lucky') {
                            return true;
                          }

                          if (desc === 'customer pay loans') {
                            return !(
                              amount &&
                              this.state.description &&
                              this.state.selectedCustomerId
                            );
                          }

                          if (
                            desc === 'employee payroll' ||
                            desc === 'transfer money to employee'
                          ) {
                            return true;
                          }

                          if (desc === 'transfer money') {
                            return !(
                              amount &&
                              this.state.description &&
                              this.state.selectedEmployeeId
                            );
                          }

                          if (desc === 'employee short payment') {
                            return !(
                              amount &&
                              this.state.description &&
                              this.state.selectedEmployeeId
                            );
                          }

                          if (desc === 'zelle') {
                            return !(
                              amount &&
                              this.state.description &&
                              !this.state.selectedEmployeeId &&
                              !this.state.selectedCustomerId
                            );
                          }

                          if (desc === 'manager loan to bank') {
                            return !(
                              amount &&
                              this.state.description &&
                              this.state.nameInput
                            );
                          }

                          // Case 3: Any other description — just needs amount & description
                          return !(amount && this.state.description);
                        })()
                      }
                    >
                      {this.state.transactionId ? 'UPDATE BANK' : 'ADD BANK'}
                    </Button>

                    <Button
                      style={{ height: '55px', flex: 1, borderRadius: '0' }}
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        // Block re-entry: ignore extra taps while a save is in
                        // flight. Critical for EXTRA MATCH / LUCKY, whose photo
                        // upload is slow enough to invite double/triple taps.
                        if (this.state.processingRequest) {
                          return;
                        }
                        this.setState({ processingRequest: true });
                        const callback = (error, response) => {
                          if (error) {
                            this.openFeedbackBar('error', response);
                          } else {
                            this.openFeedbackBar('success', response);
                          }
                          this.setState({
                            processingRequest: false,
                            transactionId: null,
                            amount: '',
                            description: '',
                            comments: '',
                            expenseType: null,
                            selectedCustomerId: null,
                            selectedEmployeeId: null,
                          });

                          this.clearAmounts();
                          this.clearPhotoState();
                        };
                        this.props.saveTransaction(
                          {
                            transactionId: this.state.transactionId,
                            amount: this.state.amount,
                            description: this.state.description,
                            comments: this.state.comments,
                            userId: this.props.userId
                              ? this.props.userId
                              : this.props.user.userId,
                            locationId: this.props.user.selectedLocationId,
                            selectedCustomerId: this.state.selectedCustomerId,
                            selectedEmployeeId: this.state.selectedEmployeeId,
                            modifyUserId: this.props.userId
                              ? this.props.user.userId
                              : null,
                            clockId: this.props.clockId,
                            nameInput: this.state.nameInput,
                            expenseType: this.state.expenseType,
                            type: 'expense',
                            amounts: amounts,
                            // Mandatory for EXTRA MATCH / LUCKY; the saga sends
                            // multipart when a photo is present.
                            photo: this.state.currentPhoto || undefined,
                          },
                          callback
                        );
                      }}
                      disabled={
                        this.state.processingRequest ||
                        (() => {
                          const desc = this.state.description?.toLowerCase();
                          const amount = this.state.amount;

                          if (desc === 'customer loans') {
                            return !(
                              amount &&
                              this.state.description &&
                              this.state.selectedCustomerId
                            );
                          }

                          if (
                            desc === 'transfer money to employee' ||
                            desc === 'transfer money'
                          ) {
                            return !(
                              amount &&
                              this.state.description &&
                              this.state.selectedEmployeeId
                            );
                          }

                          if (desc === 'extra match / lucky') {
                            return !(
                              amount &&
                              this.state.description &&
                              this.state.selectedCustomerId &&
                              // Photo required (unless editing an existing entry).
                              (this.state.currentPhoto ||
                                this.state.transactionId)
                            );
                          }

                          if (desc === 'customer pay loans') {
                            return true;
                          }

                          if (desc === 'zelle') {
                            return !(
                              amount &&
                              this.state.description &&
                              this.state.selectedEmployeeId &&
                              this.state.selectedCustomerId
                            );
                          }

                          if (desc === 'manager loan to bank') {
                            return true;
                          }

                          if (desc === 'employee short payment') {
                            return true;
                          }

                          // Case 3: Any other description — just needs amount & description
                          return !(amount && this.state.description);
                        })()
                      }
                    >
                      {this.state.transactionId
                        ? 'UPDATE EXPENSE'
                        : 'ADD EXPENSE'}
                    </Button>
                  </div>
                </div>
              ) : (
                <>
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      marginTop: '16px',
                    }}
                  >
                    <div
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        width: '50%',
                        marginRight: '16px',
                      }}
                    >
                      <Autocomplete
                        className="input-text-field"
                        style={{ width: '100%' }}
                        options={this.getDescriptionOptions()}
                        getOptionLabel={(option) => option.name || ''}
                        // Match the value based on Uppercase for production consistency
                        value={
                          this.state.description
                            ? this.getDescriptionOptions().find(
                                (cat) =>
                                  cat.name.toUpperCase() ===
                                  this.state.description.toUpperCase()
                              )
                            : null
                        }
                        onChange={(e, value) => {
                          this.setState({
                            description: value ? value.name.toUpperCase() : '',
                            expenseType:
                              value && value.expenseType
                                ? value.expenseType
                                : null,
                            // Removed showInfo: !!value so it stays hidden until clicked
                          });
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            name="description"
                            label="Description"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            required={this.state.requiredList.includes(
                              'description'
                            )}
                          />
                        )}
                      />

                      {this.state.showInfo &&
                        this.state.description &&
                        DESCRIPTION_INFO[
                          this.state.description.toUpperCase()
                        ] && (
                          <div
                            style={{
                              width: '100%',
                              marginLeft: '10px',
                              marginTop: '0px',
                              marginBottom: '8px',
                              padding: '10px 14px',
                              backgroundColor: 'white',
                              border: '1px solid #1976d2',
                              borderLeft: '5px solid #1976d2',
                              borderRadius: '4px',
                              position: 'relative',
                            }}
                          >
                            <FormHelperText
                              style={{
                                color: '#1976d2',
                                fontSize: '0.85rem',
                                margin: 0,
                                lineHeight: '1.4',
                              }}
                            >
                              <strong>Note:</strong>{' '}
                              {
                                DESCRIPTION_INFO[
                                  this.state.description.toUpperCase()
                                ]
                              }
                            </FormHelperText>
                          </div>
                        )}
                    </div>

                    <div
                      style={{
                        marginTop: '20px',
                      }}
                    >
                      <IconButton
                        size="small"
                        onClick={() =>
                          this.setState({
                            showInfo: !this.state.showInfo,
                          })
                        }
                        color={this.state.showInfo ? 'primary' : 'default'}
                        disabled={!this.state.description}
                      >
                        <InfoIcon fontSize="medium" />
                      </IconButton>
                    </div>

                    {(this.state.description.toLowerCase() ===
                      'customer loans' ||
                      this.state.description.toLowerCase() === 'zelle' ||
                      this.state.description.toLowerCase() ===
                        'extra match / lucky' ||
                      this.state.description.toLowerCase() ===
                        'customer pay loans') && (
                      <Autocomplete
                        style={{ marginTop: '10px' }}
                        className="form-input"
                        options={this.props.customers}
                        getOptionLabel={(option) =>
                          `${option.firstName} ${option.lastName}`
                        }
                        value={
                          this.state.selectedCustomerId
                            ? this.props.customers.find(
                                (c) =>
                                  c.customerId === this.state.selectedCustomerId
                              ) || null
                            : null
                        }
                        onChange={this.handleCustomerChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required
                            name="customer"
                            label="Select Customer"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                        filterOptions={(options, { inputValue }) => {
                          return options.filter(
                            (c) =>
                              c.firstName
                                .toLowerCase()
                                .includes(inputValue.toLowerCase()) ||
                              c.lastName
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                          );
                        }}
                        clearOnEscape
                      />
                    )}

                    {this.state.description.toLowerCase() ===
                      'manager loan to bank' && (
                      <TextField
                        style={{ width: '50%' }}
                        className="input-text-field"
                        variant="outlined"
                        label="Name"
                        InputLabelProps={{ shrink: true }}
                        name="name"
                        value={this.state.nameInput}
                        onChange={(e) => {
                          const value = e.target.value;
                          const capitalized =
                            value.charAt(0).toUpperCase() + value.slice(1);
                          this.setState({ nameInput: capitalized });
                        }}
                      />
                    )}

                    {(this.state.description.toLowerCase() ===
                      'employee short payment' ||
                      this.state.description.toLowerCase() ===
                        'transfer money to employee' ||
                      this.state.description.toLowerCase() ===
                        'transfer money') && (
                      <Autocomplete
                        style={{ marginTop: '10px', marginLeft: '10px' }}
                        className="form-input"
                        options={
                          this.state.description.toLowerCase() ===
                          'transfer money'
                            ? this.getTransferMoneyEmployees()
                            : (Array.isArray(this.props.employees)
                                ? this.props.employees
                                : []
                              ).filter((employee) => employee.isOnline === true)
                        }
                        getOptionLabel={(option) =>
                          [option.firstname, option.lastname]
                            .filter(Boolean)
                            .join(' ')
                        }
                        value={
                          this.state.selectedEmployeeId
                            ? this.props.employees.find(
                                (c) =>
                                  c.userId === this.state.selectedEmployeeId
                              ) || null
                            : null
                        }
                        onChange={this.handleEmployeeChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required
                            name="employee"
                            label="Select Employee"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                        filterOptions={(options, { inputValue }) => {
                          return options.filter((c) => {
                            const fullName = [c.firstname, c.lastname]
                              .filter(Boolean)
                              .join(' ')
                              .toLowerCase();
                            return fullName.includes(inputValue.toLowerCase());
                          });
                        }}
                        clearOnEscape
                      />
                    )}

                    {this.state.description.toLowerCase() === 'zelle' && (
                      <Autocomplete
                        style={{ marginTop: '10px', marginLeft: '10px' }}
                        className="form-input"
                        options={
                          Array.isArray(this.props.employees)
                            ? this.props.employees
                            : [this.props.employees]
                        }
                        getOptionLabel={(option) =>
                          [option.firstname, option.lastname]
                            .filter(Boolean)
                            .join(' ')
                        }
                        value={
                          this.state.selectedEmployeeId
                            ? this.props.employees.find(
                                (c) =>
                                  c.userId === this.state.selectedEmployeeId
                              ) || null
                            : null
                        }
                        onChange={this.handleEmployeeChange}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            required
                            name="employee"
                            label="Funds deposited to account of"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                          />
                        )}
                        filterOptions={(options, { inputValue }) => {
                          return options.filter((c) => {
                            const fullName = [c.firstname, c.lastname]
                              .filter(Boolean)
                              .join(' ')
                              .toLowerCase();
                            return fullName.includes(inputValue.toLowerCase());
                          });
                        }}
                        clearOnEscape
                      />
                    )}

                    <TextField
                      style={{ width: '50%' }}
                      className="input-text-field"
                      variant="outlined"
                      label="Amount"
                      InputLabelProps={{ shrink: true }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">$</InputAdornment>
                        ),
                      }}
                      name="amount"
                      value={this.state.amount}
                      onChange={this.handleNumberChange}
                      required={this.state.requiredList.includes('amount')}
                    />
                  </div>

                  {/* Photo requirement on its own full-width line below the
                    Description/Customer/Amount row (desktop). 16px on both sides. */}
                  {this.isPhotoRequired() && (
                    <div style={{ marginLeft: '10px', marginRight: '10px' }}>
                      {this.renderPhotoRequirement()}
                    </div>
                  )}

                  <div style={{ marginRight: '20px' }}>
                    <TextField
                      style={{ width: '100%' }}
                      variant="outlined"
                      label="Comments"
                      className="single-line-field"
                      InputLabelProps={{ shrink: true }}
                      name="comments"
                      value={this.state.comments}
                      onChange={this.handleChange}
                      multiline
                      minRows={2}
                      maxRows={6}
                    />
                  </div>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                    }}
                  >
                    <Button
                      style={{
                        height: '55px',
                        flex: 1,
                        marginRight: '10px',
                        borderRadius: '0',
                      }}
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        // Block re-entry: ignore extra taps while a save is in flight.
                        if (this.state.processingRequest) {
                          return;
                        }
                        this.setState({ processingRequest: true });
                        const callback = (error, response) => {
                          if (error) {
                            this.openFeedbackBar('error', response);
                          } else {
                            this.openFeedbackBar('success', response);
                          }
                          this.setState({
                            processingRequest: false,
                            transactionId: null,
                            amount: '',
                            description: '',
                            comments: '',
                            nameInput: null,
                            expenseType: null,
                            selectedCustomerId: null,
                            selectedEmployeeId: null,
                          });
                          this.clearAmounts();
                          this.clearPhotoState();
                        };
                        this.props.saveTransaction(
                          {
                            transactionId: this.state.transactionId,
                            amount: this.state.amount,
                            description: this.state.description,
                            comments: this.state.comments,
                            userId: this.props.userId
                              ? this.props.userId
                              : this.props.user.userId,
                            locationId: this.props.user.selectedLocationId,
                            selectedCustomerId: this.state.selectedCustomerId,
                            selectedEmployeeId: this.state.selectedEmployeeId,
                            nameInput: this.state.nameInput,
                            expenseType: this.state.expenseType,
                            modifyUserId: this.props.userId
                              ? this.props.user.userId
                              : null,
                            clockId: this.props.clockId,
                            type: 'bank',
                            amounts: amounts,
                          },
                          callback
                        );
                      }}
                      disabled={
                        this.state.processingRequest ||
                        (() => {
                          const desc = this.state.description?.toLowerCase();
                          const amount = this.state.amount;

                          // Case 1: LOAN — needs amount, description, and selectedCustomerId
                          if (
                            desc === 'customer loans' ||
                            desc === 'extra match / lucky'
                          ) {
                            return true;
                          }

                          if (desc === 'customer pay loans') {
                            return !(
                              amount &&
                              this.state.description &&
                              this.state.selectedCustomerId
                            );
                          }

                          if (
                            desc === 'employee payroll' ||
                            desc === 'transfer money to employee'
                          ) {
                            return true;
                          }

                          if (desc === 'transfer money') {
                            return !(
                              amount &&
                              this.state.description &&
                              this.state.selectedEmployeeId
                            );
                          }

                          if (desc === 'employee short payment') {
                            return !(
                              amount &&
                              this.state.description &&
                              this.state.selectedEmployeeId
                            );
                          }

                          if (desc === 'zelle') {
                            return !(
                              amount &&
                              this.state.description &&
                              !this.state.selectedEmployeeId &&
                              !this.state.selectedCustomerId
                            );
                          }

                          if (desc === 'manager loan to bank') {
                            return !(
                              amount &&
                              this.state.description &&
                              this.state.nameInput
                            );
                          }

                          // Case 3: Any other description — just needs amount & description
                          return !(amount && this.state.description);
                        })()
                      }
                    >
                      {this.state.transactionId ? 'UPDATE BANK' : 'ADD BANK'}
                    </Button>

                    <Button
                      style={{ height: '55px', flex: 1, borderRadius: '0' }}
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        // Block re-entry: ignore extra taps while a save is in
                        // flight. Critical for EXTRA MATCH / LUCKY, whose photo
                        // upload is slow enough to invite double/triple taps.
                        if (this.state.processingRequest) {
                          return;
                        }
                        this.setState({ processingRequest: true });
                        const callback = (error, response) => {
                          if (error) {
                            this.openFeedbackBar('error', response);
                          } else {
                            this.openFeedbackBar('success', response);
                          }
                          this.setState({
                            processingRequest: false,
                            transactionId: null,
                            amount: '',
                            description: '',
                            comments: '',
                            expenseType: null,
                            selectedCustomerId: null,
                            selectedEmployeeId: null,
                          });

                          this.clearAmounts();
                          this.clearPhotoState();
                        };
                        this.props.saveTransaction(
                          {
                            transactionId: this.state.transactionId,
                            amount: this.state.amount,
                            description: this.state.description,
                            comments: this.state.comments,
                            userId: this.props.userId
                              ? this.props.userId
                              : this.props.user.userId,
                            locationId: this.props.user.selectedLocationId,
                            selectedCustomerId: this.state.selectedCustomerId,
                            selectedEmployeeId: this.state.selectedEmployeeId,
                            expenseType: this.state.expenseType,
                            nameInput: this.state.nameInput,
                            modifyUserId: this.props.userId
                              ? this.props.user.userId
                              : null,
                            clockId: this.props.clockId,
                            type: 'expense',
                            amounts: amounts,
                            // Mandatory for EXTRA MATCH / LUCKY; the saga sends
                            // multipart when a photo is present.
                            photo: this.state.currentPhoto || undefined,
                          },
                          callback
                        );
                      }}
                      disabled={
                        this.state.processingRequest ||
                        (() => {
                          const desc = this.state.description?.toLowerCase();
                          const amount = this.state.amount;

                          if (
                            desc === 'transfer money to employee' ||
                            desc === 'transfer money'
                          ) {
                            return !(
                              amount &&
                              this.state.description &&
                              this.state.selectedEmployeeId
                            );
                          }

                          if (
                            desc === 'customer loans' ||
                            desc === 'extra match / lucky'
                          ) {
                            return !(
                              amount &&
                              this.state.description &&
                              this.state.selectedCustomerId &&
                              // EXTRA MATCH / LUCKY additionally requires a photo
                              // (unless editing an entry that already has one).
                              (desc !== 'extra match / lucky' ||
                                this.state.currentPhoto ||
                                this.state.transactionId)
                            );
                          }

                          if (desc === 'customer pay loans') {
                            return true;
                          }

                          if (desc === 'zelle') {
                            return !(
                              amount &&
                              this.state.description &&
                              this.state.selectedEmployeeId &&
                              this.state.selectedCustomerId
                            );
                          }

                          if (desc === 'manager loan to bank') {
                            return true;
                          }

                          if (desc === 'employee short payment') {
                            return true;
                          }

                          // Case 3: Any other description — just needs amount & description
                          return !(amount && this.state.description);
                        })()
                      }
                    >
                      {this.state.transactionId
                        ? 'UPDATE EXPENSE'
                        : 'ADD EXPENSE'}
                    </Button>
                  </div>
                </>
              )}
            </WriteGuard>

            {this.displayCurrentPage()}
          </>
        ) : (
          this.displayCurrentPage()
        )}
        {this.renderCameraOverlay()}

        <SessionReportPdf
          type="shift"
          userId={this.props.user.userId}
          locationId={this.props.user.selectedLocationId}
          locationName={this.props.user.selectedLocationName}
          trigger={this.state.reportTrigger}
          onError={this.handleReportError}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => ({
  status: statusSelector(state),
  // employees: usersSelector(state),
  employees: employeesSelector(state),
  user: userInfoSelector(state),
  transactions: transactionSelector(state),
  rollOverRequests: rollOverRequestsSelector(state),
  categories: categorySelector(state),
  customers: customersSelector(state),
});

const actionCreators = {
  clearStatus,
  listTransaction,
  deleteTransaction,
  saveTransaction,
  rollOverRequestList,
  rollOverTransaction,
  listCategory,
  listAllCustomers,
  getEmployees,
};

export default withShipment(
  {
    actionCreators,
    mapStateToProps,
  },
  Transaction
);
